'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import type { ScorecardData } from '../scorecard-types'

export const ScorecardV2Header = ({ data }: { data: ScorecardData }) => {
  const { t, locale } = useTranslation()
  const score =
    data.score != null && data.score > 0
      ? data.score.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
      : null
  const scoreLabel = `${t('product.purchase.expertRating', 'Expert rating')}: ${score} ${t('product.outOf5', 'out of 5')}`
  const scoreContent = (
    <>
      <span className="text-[2.125rem] leading-none font-extrabold tracking-[-0.03em]">{score}</span>
      <span className="text-sm font-medium">/ 5</span>
    </>
  )
  return (
    <div className="flex items-baseline justify-between gap-3">
      <h2 className="text-2xl font-semibold whitespace-nowrap text-white">
        {t('product.purchase.verdict', 'Our verdict')}
      </h2>
      {score && (
        <p aria-label={scoreLabel} className="inline-flex shrink-0 items-baseline gap-1.5 py-1 text-sky tabular-nums">
          {scoreContent}
        </p>
      )}
    </div>
  )
}
